module.exports = __webpack_public_path__ + "assets/media/empty-state.730d0077.svg";